import { navigation, React } from '@/app'
import moment from 'moment'
import { Text, View, ActionIcon, CardBase } from '@/components'
import { APIClient } from '@/services'
import { AnyFunction, arePropsEqual, TypeGuards } from '@codeleap/common'

type PostCardProps = {
  post: APIClient.Post.Post
  remove?: (id: APIClient.Post.Post['id']) => void
  edit?: AnyFunction | null,
  like?: AnyFunction
  favorite?: AnyFunction
}

const PostCardComponent = (props: PostCardProps) => {
  const {
    post,
    remove,
    edit,
    like,
    favorite,
  } = props

  const date = moment(post?.created_datetime).format('Do of MMM YY')
  const username = `${post?.profile?.first_name} ${post?.profile?.last_name}`

  return (
    <CardBase variants={['card:post']} onPress={() => navigation.navigate('Crud.View', { id: post?.id })}>
      <View variants={['row', 'justifySpaceBetween', 'fullWidth']}>
        {TypeGuards.isFunction(remove) ? (
          <ActionIcon
            onPress={remove}
            icon='x'
            variants={['minimal', 'normalize']}
            propagate={false}
          />
        ) : null}

        {TypeGuards.isFunction(edit) ? (
          <ActionIcon
            onPress={edit}
            icon='edit'
            variants={['minimal', 'normalize']}
            propagate={false}
          />
        ) : null}
      </View>

      <View variants={['row', 'justifySpaceBetween', 'fullWidth']}>
        <Text text={username} variants={['h5']} />
        <Text text={`${date}`} variants={['p2']} />
      </View>

      <Text text={post?.title} variants={['h4', 'fullWidth']} />

      <Text text={post?.content} variants={['p1']} />

      <View variants={['row', 'justifySpaceBetween', 'fullWidth']}>
        <ActionIcon
          onPress={like}
          icon={post?.is_liked ? 'heart-filled' : 'heart'}
          variants={['minimal', 'row', 'normalize']}
          propagate={false}
          disabled={!TypeGuards.isFunction(like)}
        >
          <Text text={String(post?.likes)} variants={['p2', 'primary', 'marginLeft:1']} />
        </ActionIcon>

        <ActionIcon
          onPress={favorite}
          icon={post?.is_favorited ? 'bookmark-filled' : 'bookmark'}
          variants={['minimal', 'normalize']}
          propagate={false}
          disabled={!TypeGuards.isFunction(like)}
        />
      </View>
    </CardBase>
  )
}

export const PostCard = React.memo(PostCardComponent, (previous, next) => {
  return arePropsEqual(previous, next, {
    check: ['post'],
  })
})
